import * as React from 'react';
import IFILogo from "../assets/images/ifi-logo.svg"
import FacebookLogo from "../assets/images/social-facebook.svg"
import InstagramLogo from "../assets/images/social-instagram.svg"
import TwitterLogo from "../assets/images/social-twitter.svg"
import YoutubeLogo from "../assets/images/social-youtube.svg"


function Footer() {
    const currentYear = new Date().getFullYear()

return (
    <>
<footer id="footer" role="contentinfo">
                <div className="container p-0 pb-2">
                    <div className="footer--topBorder pt-4 text-center">
                        <div className="col-sm-12 col-lg-3">
                            <a href="https://www.innovationfirst.com" target="_blank"><img className="footer--logo mb-3" src={IFILogo} alt="Innovation First, International" /></a>
                        </div>
                        <div className="footer--text col-12 col-lg-6">
                            <p>VEX and VEX Robotics are trademarks or service marks of Innovation First, Inc. <a href="https://www.vexrobotics.com/copyright-notice">Copyright &copy;{currentYear} </a>. All Rights Reserved. VEX Robotics, Inc. is a subsidiary of Innovation First International, Inc. All other product names / marks of others are the property of their respective owners. Patents and / or Patents Pending - <a href="https://www.innovationfirst.com/patents">innovationfirst.com/patents</a><br></br><a href="https://www.vexrobotics.com/privacy-policy">Site Privacy Policy</a> /<a href="https://www.vexrobotics.com/terms-of-use"> Site Terms of Use</a> / <a href="https://www.vexrobotics.com/software-privacy-policy">Software Privacy Policy</a> / <a href="https://accessibility.vex.com/">Accessibility Statement</a></p>
                        </div>
                        <div className="col-12 col-lg-3">
                            <div className="d-flex flex-row justify-content-center mt-3 mt-lg-0">
                                <a className="p-1 socialIcon" href="https://www.facebook.com/vexrobotics" target="_blank" aria-label="VEX Robotics Facebook Page"><img src={FacebookLogo} alt="Facebook Logo"/></a>
                                <a className="p-1 socialIcon" href="https://www.twitter.com/vexrobotics" target="_blank" aria-label="VEX Robotics Twitter Page"><img src={TwitterLogo} alt="Twitter Logo" /></a>
                                <a className="p-1 socialIcon" href="https://www.instagram.com/vexrobotics" target="_blank" aria-label="VEX Robotics Instagram Page"><img src={InstagramLogo} alt="Instagram Logo"/></a>
                                <a className="p-1 socialIcon" href="https://www.youtube.com/vexroboticstv" target="_blank" aria-label="VEX Robotics Youtube Page"><img src={YoutubeLogo} alt="Youtube Logo"/></a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>    
            </>
  )
}

export default Footer